import {createActions} from 'redux-actions'

export const {
    toggleHints,


} = createActions({
    TOGGLE_HINTS: () => ({}),
})